import { render, staticRenderFns } from "./scrolly.vue?vue&type=template&id=65b6e1f4&"
import script from "./scrolly.vue?vue&type=script&lang=js&"
export * from "./scrolly.vue?vue&type=script&lang=js&"
import style0 from "./scrolly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports